export default {
  computed: {
    attachmentUrl() {
      const baseUrl = `/febos-io/${process.env.VUE_APP_CODIGO_PAIS_S3}/${process.env.VUE_APP_AMBIENTE}/archivos/configuraciones`;
      switch (this.level) {
        case 'usuarioEmpresaApp': {
          return `${baseUrl}/${this.level}/${this.company.iut}/${this.application}/${this.selectedUserId ? this.selectedUserId : this.currentUser.id}/${this.param}/`;
        }
        case 'usuarioEmpresa': {
          return `${baseUrl}/${this.level}/${this.company.iut}/${this.selectedUserId ? this.selectedUserId : this.currentUser.id}/${this.param}/`;
        }
        case 'usuario': {
          return `${baseUrl}/${this.level}/${this.selectedUserId ? this.selectedUserId : this.currentUser.id}/${this.param}/`;
        }
        case 'empresaApp': {
          return `${baseUrl}/${this.level}/${this.company.iut}/${this.application}/${this.param}/`;
        }
        case 'empresa': {
          return `${baseUrl}/${this.level}/${this.company.iut}/${this.param}/`;
        }
        case 'portal': {
          return `${baseUrl}/${this.level}/${process.env.VUE_APP_DOMINIO_PORTAL}/${this.param}/`;
        }
        case 'app': {
          return `${baseUrl}/${this.level}/${this.application}/`;
        }
        default: {
          return `${baseUrl}/${this.level}/${this.param}/`;
        }
      }
    }
  },
  props: {
    hasPermisionSave: {
      type: Boolean,
      required: false,
    },
    param: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: false
    },
    parameter: {
      type: Object,
      required: false
    },
    selectedUserId: {
      type: String,
      required: false,
    },
    application: {
      type: String,
      required: false,
    }
  }
};
